import { makeStyles, Theme, Tooltip, TooltipProps, TypographyProps } from "@material-ui/core";
import Typography from "../Typography/Typography";

interface LyfeTooltipProps {
	variant?: "dark" | "light";
}

const LyfeTooltip: React.FC<TooltipProps & { typographyProps?: TypographyProps } & LyfeTooltipProps> = (props) => {
	const { variant, title, typographyProps, ...other } = props;
	const { tooltip } = classes({ variant });

	return (
		<Tooltip
			enterDelay={100}
			leaveDelay={0}
			PopperProps={{ style: { zIndex: 2001 } }}
			title={
				props.title ? (
					typeof props.title === "string" ? (
						<Typography {...typographyProps} type="semi-bold">
							{props.title}
						</Typography>
					) : (
						props.title
					)
				) : (
					""
				)
			}
			classes={{
				tooltip,
			}}
			{...other}
		>
			{props.children}
		</Tooltip>
	);
};

const classes = makeStyles<Theme & LyfeTooltipProps>((theme: Theme) => {
	const { spacing, palette, shadows } = theme;
	return {
		tooltip: {
			backgroundColor: (props) =>
				(props as LyfeTooltipProps)?.variant === "light" ? "white" : (palette.toolTipBg as any)?.main || "black",
			color: (props) => ((props as LyfeTooltipProps)?.variant === "light" ? "black" : "white"),
			padding: spacing(1),
			boxShadow: shadows[3],
		},
	};
});

export default LyfeTooltip;
